/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const PurchasableState = {
  Proto: "PROTO",
  Active: "ACTIVE",
  Voided: "VOIDED",
  Revoked: "REVOKED",
  RevokedRefunded: "REVOKED_REFUNDED",
  RevokedRefundedPartially: "REVOKED_REFUNDED_PARTIALLY",
} as const;

export type PurchasableState =
  (typeof PurchasableState)[keyof typeof PurchasableState];

export type PurchasableStateEnumType = typeof PurchasableState;
export type PurchasableStateOptional = PurchasableState;
export type PurchasableStateTrackedI = PurchasableState;
export type PurchasableStateTracked = PurchasableState;
export type PurchasableStateMetaI = EnumMetaType<
  PurchasableStateEnumType,
  PurchasableState
>;
export const PurchasableStateMeta = typeMetaEnum<
  PurchasableStateEnumType,
  PurchasableState
>("PurchasableState", PurchasableState);
export function transformDatesPurchasableState(model: PurchasableState) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
